import { Flex, Typography } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

type Props = {
  question: string;
};
export const DepreciationQuestion = ({ question, children }: PropsWithChildren<Props>) => (
  <Flex flexDirection="column" gap=".5rem">
    <Typography variant="h3">{question}</Typography>
    <Flex paddingX="1rem">{children}</Flex>
  </Flex>
);
